import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.object.assign";
import * as React from 'react';
import { createElement, Suspense, useState, useEffect, forwardRef, useCallback, useContext, useMemo, memo, Fragment } from 'react';
import loadable from '@loadable/component';
import _get from 'lodash/fp/get';
import { __rest } from 'tslib';
import { a as isFn, b as useComponents, c as doczState } from './chunk.esm.js';
export { j as ComponentsProvider, c as doczState, b as useComponents, d as useConfig, e as useDataServer, f as useDocs, g as useMenus, h as usePrevious, i as useWindowSize } from './chunk.esm.js';
import _omit from 'lodash/fp/omit';
import { Link as Link$1, createHistory, LocationProvider, Router } from '@reach/router';
import _first from 'lodash/fp/first';
import capitalize from 'capitalize';
import 'fast-deep-equal';
import 'lodash/fp/merge';
import 'array-sort';
import 'lodash/fp/unionBy';
import 'lodash/fp/flattenDepth';
import 'lodash/fp/pipe';
import 'ulid';
import 'match-sorter';
import 'lodash/fp/throttle';
import { MDXProvider } from '@mdx-js/react';
var BasePlayground = loadable(function () {
  return import('./Playground.esm.js');
});

var Playground = function Playground(props) {
  return typeof window !== 'undefined' ? createElement(Suspense, {
    fallback: null
  }, createElement(BasePlayground, Object.assign({}, props))) : null;
};

var AsyncComponent = function AsyncComponent(defaultProps) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      data = _useState6[0],
      setData = _useState6[1];

  useEffect(function () {
    var getInitialProps = defaultProps.getInitialProps;

    if (getInitialProps && isFn(getInitialProps)) {
      setLoading(true);
      getInitialProps(defaultProps).then(function (data) {
        setLoading(false);
        setError(null);
        setData(data);
      })["catch"](function (err) {
        setLoading(false);
        setError(err);
        setData({});
      });
    }
  }, []);

  var Comp = defaultProps.as,
      getInitialProps = defaultProps.getInitialProps,
      props = __rest(defaultProps, ["as", "getInitialProps"]);

  return createElement(Comp, Object.assign({}, props, {
    data: Object.assign({}, data, {
      loading: loading,
      error: error
    })
  }));
};

var loadRoute = function loadRoute(path, imports, components) {
  var Loading = components.loading;

  var fn =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var importFn, _ref2, Component, getInitialProps, ExportedComponent;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              importFn = _get(path, imports);
              _context.next = 3;
              return importFn();

            case 3:
              _ref2 = _context.sent;
              Component = _ref2["default"];
              getInitialProps = _ref2.getInitialProps;

              ExportedComponent = function ExportedComponent(props) {
                return createElement(AsyncComponent, Object.assign({}, props, {
                  as: Component || 'div',
                  getInitialProps: getInitialProps
                }));
              };

              return _context.abrupt("return", ExportedComponent);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fn() {
      return _ref.apply(this, arguments);
    };
  }();

  return loadable(fn, {
    fallback: createElement(Loading, null)
  });
};

var AsyncRoute = function AsyncRoute(defaultProps) {
  var asyncComponent = defaultProps.asyncComponent,
      path = defaultProps.path,
      entry = defaultProps.entry,
      routeProps = __rest(defaultProps, ["asyncComponent", "path", "entry"]);

  var components = useComponents();
  var Page = components.page;
  var Component = asyncComponent;
  var props = Object.assign({}, routeProps, {
    doc: entry
  });
  return Page ? createElement(Page, Object.assign({}, props), createElement(Component, Object.assign({}, props))) : createElement(Component, Object.assign({}, props));
};

var Link = forwardRef(function (defaultProps, ref) {
  var props = _omit(['activeClassName', 'partiallyActive'], defaultProps);

  var isActive = useCallback(function (_ref3) {
    var isCurrent = _ref3.isCurrent;
    return isCurrent ? {
      className: "".concat(props.className, " active")
    } : {};
  }, [props.className]);
  return createElement(Link$1, Object.assign({}, props, {
    getProps: isActive,
    ref: ref
  }));
});
Link.displayName = 'Link';
var RE_OBJECTOF = /(?:React\.)?(?:PropTypes\.)?objectOf\((?:React\.)?(?:PropTypes\.)?(\w+)\)/;

var getTypeStr = function getTypeStr(type) {
  switch (type.name.toLowerCase()) {
    case 'instanceof':
      return "Class(".concat(type.value, ")");

    case 'enum':
      if (type.computed) return type.value;
      return type.value ? type.value.map(function (v) {
        return "".concat(v.value);
      }).join(' │ ') : type.raw;

    case 'union':
      return type.value ? type.value.map(function (t) {
        return "".concat(getTypeStr(t));
      }).join(' │ ') : type.raw;

    case 'array':
      return type.raw;

    case 'arrayof':
      return "Array<".concat(getTypeStr(type.value), ">");

    case 'custom':
      if (type.raw.indexOf('function') !== -1 || type.raw.indexOf('=>') !== -1) return 'Custom(Function)';else if (type.raw.toLowerCase().indexOf('objectof') !== -1) {
        var m = type.raw.match(RE_OBJECTOF);
        if (m && m[1]) return "ObjectOf(".concat(capitalize(m[1]), ")");
        return 'ObjectOf';
      }
      return 'Custom';

    case 'bool':
      return 'Boolean';

    case 'func':
      return 'Function';

    case 'shape':
      var shape = type.value;
      var rst = {};
      Object.keys(shape).forEach(function (key) {
        rst[key] = getTypeStr(shape[key]);
      });
      return JSON.stringify(rst, null, 2);

    default:
      return capitalize(type.name);
  }
};

var humanize = function humanize(type) {
  return getTypeStr(type);
};

var getPropType = function getPropType(prop) {
  var propName = _get('name', prop.flowType || prop.type);

  if (!propName) return null;
  var isEnum = propName.startsWith('"') || propName === 'enum';
  var name = capitalize(isEnum ? 'enum' : propName);

  var value = _get('type.value', prop);

  if (!name) return null;

  if (isEnum && typeof value === 'string' || !prop.flowType && !isEnum && !value || prop.flowType && !prop.flowType.elements) {
    return name;
  }

  return prop.flowType ? humanize(prop.flowType) : humanize(prop.type);
};

var Props = function Props(_ref4) {
  var title = _ref4.title,
      isToggle = _ref4.isToggle,
      isRaw = _ref4.isRaw,
      component = _ref4.of;
  var components = useComponents();

  var _useContext = useContext(doczState.context),
      stateProps = _useContext.props;

  var PropsComponent = components.props;

  var filename = _get('__filemeta.filename', component);

  var filemetaName = _get('__filemeta.name', component);

  var componentName = filemetaName || component.displayName || component.name;
  var found = stateProps && stateProps.length > 0 && stateProps.find(function (item) {
    return filename ? item.key === filename : item.key.includes("".concat(componentName, "."));
  });
  var value = _get('value', found) || [];

  var firstDefinition = _first(value);

  var definition = value.find(function (i) {
    return i.displayName === componentName;
  });

  var props = _get('props', definition || firstDefinition);

  if (!props) return null;
  if (!PropsComponent) return null;
  return createElement(PropsComponent, {
    title: title,
    isRaw: isRaw,
    isToggle: isToggle,
    props: props,
    getPropType: getPropType
  });
};

var goToHash = function goToHash(_ref5) {
  var location = _ref5.location;
  setTimeout(function () {
    if (location && location.hash) {
      var decodedHash = decodeURI(location.hash);
      var id = decodedHash.substring(1);
      var el = document.getElementById(id);
      if (el) el.scrollIntoView();
    }
  });
};

var Routes = function Routes(_ref6) {
  var imports = _ref6.imports;
  var components = useComponents();

  var _useContext2 = useContext(doczState.context),
      entries = _useContext2.entries;

  var NotFound = components.notFound;
  var history = useMemo(function () {
    return createHistory(window);
  }, []);
  useEffect(function () {
    history.listen(goToHash);
  }, []);
  return createElement(MDXProvider, {
    components: components
  }, createElement(LocationProvider, {
    history: history
  }, createElement(Router, null, createElement(NotFound, {
    "default": true
  }), entries && entries.map(function (_ref7) {
    var path = _ref7.key,
        entry = _ref7.value;
    var props = {
      path: path,
      entries: entries,
      components: components
    };
    var component = loadRoute(path, imports, components);
    return createElement(AsyncRoute, Object.assign({}, props, {
      entry: entry,
      key: entry.id,
      path: entry.route,
      asyncComponent: component
    }));
  }))));
};

function theme(themeConfig) {
  var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (c) {
    return c;
  };
  return function (WrappedComponent) {
    var Theme = memo(function (props) {
      var linkComponent = props.linkComponent;
      var db = props.db,
          children = props.children,
          _props$wrapper = props.wrapper,
          Wrapper = _props$wrapper === void 0 ? Fragment : _props$wrapper;
      var initial = Object.assign({}, db, {
        themeConfig: themeConfig,
        transform: transform,
        linkComponent: linkComponent
      });
      return createElement(doczState.Provider, {
        initial: initial
      }, createElement(Wrapper, null, createElement(WrappedComponent, null, children)));
    });
    Theme.displayName = WrappedComponent.displayName || 'DoczTheme';
    return Theme;
  };
}

export { AsyncRoute, Link, Playground, Props, Routes, loadRoute, theme };